import BundlesDetailsModal from './BundlesDetailsModal';

export default BundlesDetailsModal;
